import React, { useState } from "react";
import Loader from "designs/v1/pages/ModifyKyc/components/Loader";
import Review from "./Review";
import ESignature from "./ESignature";

const MultipleReview = ({ stageScreen, setStageScreen }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [step, setStep] = useState("Review");

  const getStepScreen = (step) => {
    let html = null;
    switch (step) {
      case "Review":
        html = (
          <Review
            stageScreen={stageScreen}
            setStageScreen={setStageScreen}
            setStep={setStep}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
          />
        );
        break;
      case "ESignature":
        html = (
          <ESignature
            stageScreen={stageScreen}
            setStageScreen={setStageScreen}
            setStep={setStep}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
          />
        );
        break;
      default:
        break;
    }
    return html;
  };
  return (
    <React.Fragment>
      {isLoading && <Loader />}
      {getStepScreen(step)}
    </React.Fragment>
  );
};

export default MultipleReview;
